import { Component } from '@angular/core';
import {language} from '../../language/vn';

@Component({
  templateUrl: '404.component.html'
})
export class P404Component {
  public language = language;
  constructor() { }

}
